






























































import { AxiosError } from 'axios';
import { defineComponent, PropType, computed, ref } from '@vue/composition-api';

import { IWorkflowStateThreshold } from '@/models';
import { ISystemError } from '@/models/error/error.types';

import auth from '@/mixins/auth';
import { useDeleteThreshold } from '@/composable/useWorkflowStateThreshold';
import { setErrorFromAxiosError } from '@/utils/helpers';

import AlTooltipBtn from '../common/AlTooltipBtn.vue';
import DetailOptionsButton from '../common/DetailOptionsButton.vue';
import DeleteConfirmationDialog from '../common/DeleteConfirmationDialog.vue';

export default defineComponent({
  name: 'WorkflowStateThresholdDetail',

  components: {
    AlTooltipBtn,
    DetailOptionsButton,
    DeleteConfirmationDialog
  },

  props: {
    threshold: {
      type: Object as PropType<IWorkflowStateThreshold>,
      required: true
    },

    workflowId: { type: Number, required: true },

    workflowStateId: { type: Number, required: true }
  },

  mixins: [auth],

  setup(props) {
    const localError = ref<ISystemError | null>(null);

    const deleteError = computed<ISystemError | null>({
      get() {
        let systemError: ISystemError | null = localError.value;
        const axiosError = deleteThresholdError.value;

        if (axiosError) {
          systemError = setErrorFromAxiosError(axiosError as AxiosError);
        }

        return systemError;
      },
      set(value: ISystemError | null) {
        localError.value = value;
      }
    });
    const deleteThresholdDialog = ref(false);

    const {
      deleteThresholdErrorReset,
      deleteThreshold,
      isDeletingThreshold,
      deleteThresholdError
    } = useDeleteThreshold(props.workflowId, props.workflowStateId);

    function cancelDeleteDialog() {
      deleteThresholdDialog.value = false;
    }

    function removeThreshold() {
      deleteError.value = null;
      deleteThreshold(props.threshold.id!, {
        onSuccess: () => {
          deleteThresholdDialog.value = false;
        }
      });
    }

    return {
      deleteError,
      deleteThresholdDialog,
      isDeleteInProgress: isDeletingThreshold,

      cancelDeleteDialog,
      removeThreshold
    };
  }
});
